import React, { useEffect, useState } from 'react'
import classes from "./styles.module.scss";
import Table from '../../components/table';
import { Columns } from './constant/columns';
import ActionButton from '../../components/actionButton';
import { Link } from 'react-router-dom';
import MeetingPopupDialog from '../../components/meetingPopupDialog';
import EditAddWebinarModal from './editAddWebinarModal';
import PrimaryButton from '../../components/buttons';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AssignMentorModal from '../orderTable/assignMentorModal';
import { actionNotifier } from '../../components/ui/toast';
import { apiLoadingOverlay, apiLoadingOverlayEnd } from '../../store/loader/loadingSlice';
import { getOrderCounselorOrMentor, updateOrderCounselorOrMentor } from '../../pages/viewOrders/actions';
import { camelToSentenceCase, convertToTitleCase, throwError } from '../../shared/counsellorFunction';
import { useDispatch } from 'react-redux';
import { apiFunction } from '../../apiCalls/functions';
import CheckBoxText from '../../components/checkBoxText';
import { dateFormatUTCtoLocal, formatUTCtoUTCDateMnameYearTime, removeFiveThirty } from '../../shared/dateFunction';
import DownloadIcon from '@mui/icons-material/Download';
import { cleanDigitSectionValue } from '@mui/x-date-pickers/internals/hooks/useField/useField.utils';

const ViewWebinarContainer = (props) => {
    const dispatch = useDispatch()

    const [row, setRow] = useState([])
    const [selectedMeetingLink, setSelectedMeetingLink] = useState(null);
    const [isDialogOpen, setDialogOpen] = useState(false);

    const ActionInQueue = ({ id, meetingLink, data }) => {
        return (
            <div className={classes.action_container}>
                <ActionButton
                    type="button"
                    icon="fa fa-eye"
                    title="View Details"
                    label="View Details"
                    onClick={() => window.location.href = props.role === "admin" ? `/admin/webinar/${id}` : `/counselor/webinar/${id}`}
                />
                <ActionButton
                    type="button"
                    icon="fa fa-play"
                    title="Start"
                    label="Start"
                    onClick={() => {
                        setSelectedMeetingLink(meetingLink);
                        setDialogOpen(true);
                    }}
                />
                {data?.recLink && (
                    <ActionButton
                        type="button"
                        icon="fa fa-video-camera"
                        title="Recording"
                        label="Recording"
                        onClick={() => window.open(data.recLink, '_blank')}
                    />
                )}
                {props.role === "admin" && (
                    <ActionButton
                        type="button"
                        onClick={() => setOpenAssignCheckerModal({
                            from: "webinar",
                            status: true,
                            webinarId: id,
                            attachedMentor: data?.Counselor?.map((c) => c.id) || []
                        })}
                        title="Assign Mentor"
                        icon="fa fa-user-plus"
                    />
                )}
                {props.role === "admin" && (
                    <ActionButton
                        type="button"
                        icon="fa fa-edit"
                        title="Edit"
                        label="Edit"
                        onClick={() => {
                            setSelectedWebinar(data);
                            setIsWebinarModalOpen(true);
                        }}
                    />
                )}
            </div>
        );
    };


    const handleChecked = (id) => {
        // let _assignData = { ...props?.assignData }
        let index = props?.assignData?.findIndex(f => f == id)
        if (index >= 0) {
            return true
        }
        return false;
    }

    const handleCheckbox = (id) => {
        // e.preventDefault()
        const index = props?.assignData?.findIndex(item => item === id);
        if (index !== -1) {
            const updatedAssignData = props?.assignData?.filter(item => item !== id);
            props.setAssignData(updatedAssignData);
        } else {
            props.setAssignData(prevData => [...prevData, id]);
        }
    };




    const generateRowsByStatus = (data) => {
        if (data) {
            return data.map((f, index) => ({
                checkbox: <CheckBoxText value={handleChecked(f.id)} onClick={(e) => handleCheckbox(f.id)} />,
                id: `${(props?.page - 1) * props?.countPerPage + index + 1}`.padStart(2, '0'),
                name: f?.name || '',
                date: formatUTCtoUTCDateMnameYearTime(f?.onDateTime) || '',
                duration: `${f?.meetingTime} mins` || '',
                language: f?.Language?.name || '',
                counselorName: (f?.Counselor && f?.Counselor?.map(item => item?.name).filter(Boolean).join(', ')) || '',
                counselorStatus: f?.Counselor?.CAStatus || '',
                type: (f?.type && convertToTitleCase(f?.type)) || '',
                // meetingLink: f?.meetingLink || '',
                recLink: f?.recordingLink ? (
                    <div className={classes.iconTxt} onClick={() => { window.open(f?.recordingLink, "_blank") }}>
                        <DownloadIcon style={{ color: 'blue' }} className={classes.icon} />
                        <div style={{ color: 'blue' }}></div>
                    </div>
                ) : null,
                action: <ActionInQueue id={f?.id} meetingLink={f?.meetingLink} data={f} />,
            }));
        }
        return [];
    };




    useEffect(() => {
        if (props?.data && props.data?.rows) {
            const rows = props.data?.rows || []
            const newRows = generateRowsByStatus(rows);
            setRow(newRows);
        }

    }, [props.data, props.assignData]);

    const handleStartMeeting = () => {
        setDialogOpen(false);
        // props.onStartMeeting();
        if (selectedMeetingLink) {
            window.open(selectedMeetingLink, '_blank');
        }
        setSelectedMeetingLink(null);
    }

    const mentorInstructionsJson = [
        // <>Ensure you’re logged into <b>mentorme@prepca.com</b> in this browser/profile. Sessions started with any other ID won’t be <b>recorded</b>, won’t be counted, and won’t be considered for commercials (no payment will be processed).</>,
        <>After clicking “Start”, you must click “Join” on the Google Meet page to begin the session.</>
    ];

    const [isWebinarModalOpen, setIsWebinarModalOpen] = useState(false);
    const [selectedWebinar, setSelectedWebinar] = useState(null);

    const handleOpenWebinarModal = (webinar = null) => {
        setSelectedWebinar(null);
        setIsWebinarModalOpen(true);
    };

    const handleCloseWebinarModal = () => {
        setSelectedWebinar(null);
        setIsWebinarModalOpen(false);
    };

const handleSaveWebinar = async (data, close) => {
    try {
        let formattedMeetingTime = data.meetingTime;

        if (!formattedMeetingTime.endsWith("Z")) {
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(formattedMeetingTime)) {
                formattedMeetingTime = `${formattedMeetingTime}:00Z`;
            } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(formattedMeetingTime)) {
                formattedMeetingTime = `${formattedMeetingTime}Z`;
            }
        }

        const newTimeISO = new Date(formattedMeetingTime).toISOString();
        const existingTimeISO = selectedWebinar?.onDateTime
            ? new Date(selectedWebinar.onDateTime).toISOString()
            : null;

        const shouldSendMeetingTime = !selectedWebinar || newTimeISO !== existingTimeISO;

        const payload = {
            ...data,
            meetingTime: shouldSendMeetingTime ? newTimeISO : undefined,
        };

        if (selectedWebinar) {
            await props.assignMentorToWebinar({
                webinarId: selectedWebinar.id,
                ...payload
            }).unwrap();
        } else {
            await props.createWebinar(payload).unwrap();
        }

        close();
        setSelectedWebinar(null);
        setIsWebinarModalOpen(false);
    } catch (error) {
        throwError(error, "Failed to save webinar");
    }
};




    const assignWebinarToMentor = async (data) => {
        return await apiFunction("/admin/counselor/update-webinar", 'post', data, true, false)
    }

    const [openAssignCheckerModal, setOpenAssignCheckerModal] = useState({ from: "", status: false, webinarId: "", attachedMentor: [] });

    const [assignData, setAssignData] = useState([]);
    // console.log("🚀 ~ ViewWebinarContainer ~ assignData:", assignData)

    useEffect(() => {
        if (openAssignCheckerModal.webinarId) {
            setAssignData(openAssignCheckerModal.attachedMentor || []);
        }
    }, [openAssignCheckerModal.webinarId, dispatch]);

    useEffect(() => {
        if (openAssignCheckerModal.webinarId) {
            setAssignData(openAssignCheckerModal.attachedMentor || []);
        }
    }, [openAssignCheckerModal.webinarId, dispatch]);

    const handleAssignMentor = async () => {
        // if (!openAssignCheckerModal.webinarId) {
        //     actionNotifier.error("webinarId is missing!");
        //     return;
        // }

        // if (assignData.length === 0) {
        //     actionNotifier.error("No mentors selected!");
        //     return;
        // }

        const payload = {
            webinarId: openAssignCheckerModal.webinarId,
            counselorIds: assignData,
        };

        try {
            await props.assignMentorToWebinar(payload).unwrap();
            actionNotifier.success("Mentor assigned successfully");
            setAssignData([]);
            setOpenAssignCheckerModal({ from: "", status: false, webinarId: "" });
        } catch (error) {
            throwError(error, "Failed to assign mentor");
        }
    };

    // useEffect(() => {
    //     if (!openAssignCheckerModal.webinarId) return;

    //     (async () => {
    //         try {
    //             const res = await getOrderCounselorOrMentor(openAssignCheckerModal.webinarId);
    //             if (res.status) {
    //                 setAssignData(res.data.map((mentor) => mentor?.id));
    //             } else {
    //                 actionNotifier.error("Failed to fetch mentor data");
    //             }
    //         } catch (error) {
    //             throwError(error, "Failed to fetch mentor data");
    //         }
    //     })();
    // }, [openAssignCheckerModal.webinarId]);


    console.log(selectedWebinar, "selectedWebinar");
    // const handleCheckerRadio = ((checkerId) => {
    //     // alert(checkerId)
    //     let _assignData = { ...assignData }
    //     let index = _assignData.checkerId = Number(checkerId)
    //     setAssignData(_assignData)
    // });
    const closeModal = () => {
        setAssignData([]);
        setOpenAssignCheckerModal({ from: "", status: false, webinarId: "", attachedMentor: [] });
    }


    return (
        <>

            {props.role === "admin" && <div className={classes.add_buttons}>
                <PrimaryButton
                    buttonText="ADD ONE WEBINAR"
                    icon={<AddCircleIcon />}
                    onClick={handleOpenWebinarModal}
                />
            </div>}
            <div className={classes.table_container} >

                <div className={classes.table_desktop} ref={props.cardRef}>
                    <div className={classes.card} >
                        <Table
                            rows={row || []}
                            columns={Columns || []}
                            total={props.total}
                            page={props.page}
                            handlePage={props.onChange}
                            pageNo={props.page}
                        />
                    </div>
                </div>

            </div>

            <MeetingPopupDialog
                open={isDialogOpen}
                setOpen={setDialogOpen}
                onStartMeeting={handleStartMeeting}
                title="Before You Start"
                instructions={mentorInstructionsJson}
            />
            <EditAddWebinarModal
                open={isWebinarModalOpen}
                close={handleCloseWebinarModal}
                onSave={handleSaveWebinar}
                initialData={selectedWebinar}
            />

            {props.role === "admin" && <AssignMentorModal
                assignData={assignData}
                setAssignData={setAssignData}
                close={closeModal}
                orderId={openAssignCheckerModal.webinarId}
                open={openAssignCheckerModal.status}
                handleAssignMentor={handleAssignMentor}
            // close={() => setOpenAssignCheckerModal({ from: "", status: false, webinarId: "" })}
            />}
        </>
    )
}

export default ViewWebinarContainer
